module.exports = __webpack_public_path__ + "img/chip.4f9f2b09.svg";